import store from '../store/store';
import { createHiddenSsoDialog } from '../store/schema/interfaces/ActiveSsoDialog';
import { getSsoDialog } from 'owa-addins-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('hideSsoDialog', function(controlId?: string) {
    const dialog = getSsoDialog();
    if (!controlId || (dialog.isOpen && dialog.controlId === controlId)) {
        store.activeSsoDialog = createHiddenSsoDialog();
    }
});
